// Libraries
import {
  NgModule
} from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Interceptors
import { HandleResponseErrorsInterceptor } from './handle-response-errors.interceptor';

/**
 * `HandleResponseErrorsModule` Here you will intercept backend request and handle http errors.
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 * @export
 */
@NgModule({
  declarations: [
  ],
  exports: [
  ],
  imports: [
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HandleResponseErrorsInterceptor, multi: true }
  ]
})
export class HandleResponseErrorsModule {
}
